import { Tabs } from "./Tabs";
import { AccordionTabContent } from "./AccordionTabContent";
export { Tabs, AccordionTabContent };
